import { render, staticRenderFns } from "./ApplicationLinkEmailCopy.vue?vue&type=template&id=55ce5ccc"
import script from "./ApplicationLinkEmailCopy.vue?vue&type=script&lang=js"
export * from "./ApplicationLinkEmailCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports